
export default {
  name: 'AppSpinner',
};
